import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { CaoService } from 'src/app/services/cao.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { IpAddressService } from 'src/app/services/ip-address.service';

@Component({
  selector: 'app-lot-wise-report',
  templateUrl: './lot-wise-report.component.html',
  styleUrls: ['./lot-wise-report.component.scss']
})
export class LotWiseReportComponent implements OnInit {

  dropDownList: { type: any, value: any }[];
  applicationSelected: any;
  responseDate: any;
  cols: any[];

  constructor(
    private route: ActivatedRoute,
    private ipService: IpAddressService, 
    private caoService: CaoService, 
    private messageService: MessageService, 
    private router: Router,
    private activityRecordService: ActivityRecordService,
    private cryptoJsService: CryptoJsService
    ) { }

  autoId: any;
  appId: any;
  items: any[];
  userID: any;

  ngOnInit(): void {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    this.activityRecordService.activityRecord(this.userID, 'View All Subsidy Lot', '', new Date(), 'Success');

    let parentRoute = this.router.url.split('/')[1];
    this.route.queryParams

    if(this.router.url.startsWith('/cao') || this.router.url.startsWith('/department')) {
      this.dropDownList = [
        {
          type: 'Farmer Share To vendor', value: `/report/lot-wise-report/fsv`
        },
        {
          type: 'Subsidy To Farmer', value: `/report/lot-wise-report/stf`
        },
        {
          type: 'Subsidy To Vendor', value: `/report/lot-wise-report/stv`
        },
        {
          type: 'Refund To Farmer', value: `/report/lot-wise-report/rtf`
        },
        {
          type: 'Stage 1', value: `/report/lot-wise-report/stage1`
        },
        {
          type: 'Stage 2', value: `/report/lot-wise-report/stage2`
        },
        {
          type: 'Stage 3', value: `/report/lot-wise-report/stage3`
        },
      ]
    }
    
  }

  onApplicationTypeSelected(event) {
    let parentRoute = this.router.url.split('/')[1];
    this.router.navigate([`/${parentRoute.concat(event.value.value)}`])
  }

}
